import { Box, Container, Typography } from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import storyImg from "../../assets/images/about_ss.png";
import storyImgm from "../../assets/images/about_ss_m.png";
import cardBg from "../../assets/images/a_card_bg.png";

const features = [
  "Professional Cleaning",
  "Alterations & Repairs",
  "Pickup & Delivery",
  "Experienced Professionals",
  "Shoe Care & Repairs",
  "Custom Printing",
];
export default function OurStory() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        position: "relative",
        backgroundImage: {
          xs: `url(${storyImgm})`,
          md: `url(${storyImg})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",

        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",

            flexDirection: {
              xs: "column",
              lg: "row",
            },

            alignItems: "center",

            gap: {
              xs: 5,
              md: 8,
            },
          }}
        >
          {/* LEFT IMAGE */}

          <Box
            sx={{
              width: {
                xs: "100%",
                lg: "48%",
              },

              display: "flex",

              justifyContent: "center",
            }}
          >
            {/* <Box
              sx={{
                width: "100%",

                maxWidth: "620px",

                borderRadius: {
                  xs: "28px",
                  md: "40px",
                },

                overflow: "hidden",

                position: "relative",

                boxShadow: "0 30px 80px rgba(0,87,255,.12)",
              }}
            >
              <Box
                component="img"
                src={storyImg}
                alt="Comet Cleaners"
                sx={{
                  width: "100%",

                  display: "block",

                  objectFit: "cover",
                }}
              />
            </Box> */}
          </Box>

          {/* RIGHT CONTENT */}

          <Box
            sx={{
              width: {
                xs: "100%",
                lg: "52%",
              },

              textAlign: {
                xs: "center",
                lg: "left",
              },
            }}
          >
            {/* BADGE */}

            <Box
              sx={{
                display: "inline-flex",

                px: 2.5,

                py: 1,

                borderRadius: "50px",

                background: "rgba(0,87,255,.08)",

                color: "#0057FF",

                fontSize: "12px",

                fontWeight: 800,

                letterSpacing: "1px",

                textTransform: "uppercase",
              }}
            >
              Our Story
            </Box>

            {/* HEADING */}

            <Typography
              sx={{
                mt: 2.5,

                fontWeight: 900,

                color: "#07122F",

                lineHeight: 1.08,

                fontSize: {
                  xs: "32px",
                  sm: "32px",
                  md: "56px",
                  lg: "56px",
                },
              }}
            >
              Built On Trust,
              <br />
              <Box
                component="span"
                sx={{
                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  WebkitBackgroundClip: "text",

                  WebkitTextFillColor: "transparent",
                }}
              >
                Quality & Convenience
              </Box>
            </Typography>

            {/* DESCRIPTION */}

            <Typography
              sx={{
                mt: 3,

                color: "#64748B",

                lineHeight: 1.9,

                fontSize: {
                  xs: "13px",
                  sm: "14px",
                  md: "16px",
                },
              }}
            >
              At Comet Cleaners, we believe every item deserves exceptional
              care. From everyday clothing and footwear to wedding garments,
              handbags, rugs and home essentials, our experienced team combines
              professional expertise with modern equipment to deliver
              outstanding results. Our goal is simple — provide convenient,
              reliable and high-quality care services that help our customers
              save time while keeping their valued items looking their best.
            </Typography>

            {/* FEATURE CARDS */}

            <Box
              sx={{
                mt: {
                  xs: 3,
                  md: 5,
                },

                display: "grid",

                gridTemplateColumns: {
                  xs: "1fr 1fr", // 2 cards per row on mobile
                  sm: "1fr 1fr",
                },

                gap: {
                  xs: 1.2,
                  md: 2,
                },
              }}
            >
              {features.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    position: "relative",

                    display: "flex",

                    alignItems: "center",

                    gap: {
                      xs: 1,
                      md: 1.5,
                    },

                    p: {
                      xs: 1.2,
                      md: 2,
                    },

                    borderRadius: {
                      xs: "16px",
                      md: "22px",
                    },

                    backgroundImage: `
          // linear-gradient(
          // rgba(255,255,255,.92),
          // rgba(248,251,255,.88)
          // ),
          url(${cardBg})
        `,

                    backgroundSize: "cover",

                    backgroundPosition: "bottom",

                    backdropFilter: "blur(18px)",

                    border: "1px solid rgba(255,255,255,.8)",

                    boxShadow:
                      "0 10px 35px rgba(0,87,255,.08), inset 0 1px 0 rgba(255,255,255,.9)",

                    transition: ".35s ease",

                    overflow: "hidden",

                    "&::before": {
                      content: '""',

                      position: "absolute",

                      left: 0,

                      top: 12,

                      bottom: 12,

                      width: "4px",

                      borderRadius: "20px",

                      background: "linear-gradient(180deg,#0057FF,#1DB6FF)",
                    },

                    "&:hover": {
                      transform: "translateY(-5px)",

                      boxShadow: "0 20px 50px rgba(0,87,255,.15)",

                      "&::before": {
                        width: "6px",
                      },
                    },
                  }}
                >
                  {/* ICON */}

                  <Box
                    sx={{
                      minWidth: {
                        xs: 28,
                        md: 38,
                      },

                      width: {
                        xs: 28,
                        md: 38,
                      },

                      height: {
                        xs: 28,
                        md: 38,
                      },

                      borderRadius: "50%",

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",

                      background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                      color: "#fff",

                      boxShadow: "0 8px 20px rgba(0,87,255,.25)",
                    }}
                  >
                    <CheckCircleIcon
                      sx={{
                        fontSize: {
                          xs: 16,
                          md: 20,
                        },
                      }}
                    />
                  </Box>

                  {/* TEXT */}

                  <Typography
                    sx={{
                      fontWeight: 700,

                      color: "#12305F",

                      lineHeight: 1.3,

                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "15px",
                      },
                    }}
                  >
                    {item}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
